module.exports = {
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],

    /* 01. Common */
    'common.actions.add': 'Add',
    'common.actions.confirm': 'Confirm',
    'common.actions.submit': 'Submit',
    'common.actions.cancel': 'Cancel',
    'common.actions.loading': 'Loading...',
    'common.actions.update': 'Update',
    'common.actions.orderby': 'Order By',
    'common.actions.lockScreen': 'Lock Screen',
    'common.actions.allDevices': 'All Devices',
    'common.actions.messages': 'Messages',
    'common.actions.changePassword': 'Change Password',
    'common.actions.logout': 'Logout',
    'common.actions.printCheck': 'Print Check',
    'common.actions.checkIt': 'Check It',
    'common.actions.addTicket': 'Add To Betslip',

    'common.list': 'List',
    'common.cashier': 'Cashier',
    'common.confirmDeleteTitle': 'Are you sure to delete?',
    'common.currentLimit': 'Current Balance',
    'common.remainingLimit': 'Current Balance',
    'common.live': 'Live',
    'common.goal': 'goal',

    /* ================================================================================================================================ */

    /* 02. Menu */
    'menu.home': 'Home',
    'menu.sports': 'Sports',
    'menu.live': 'Live',
    'menu.e-sports': 'E-Sports',
    'menu.prematch': 'Prematch',
    'menu.results': 'Results',
    'menu.printProgram': 'Print The Program',
    'menu.dailyReport': 'Report',
    'menu.balanceReport': 'Balance Report',
    'menu.point': 'Others',
    'menu.point.creditLimit': 'Interim Payment',
    'menu.actions.playNow': 'Play Now',
    'menu.actions.playLive': 'Play Live',
    'menu.actions.look': "Let's look",
    'menu.actions.printNow': 'Print Now',
    'menu.actions.increase': 'Increase',

    /* ================================================================================================================================= */

    /* 03. Input & SelectBox */
    'input.placeholder.voucherAmount': 'Voucher Amount',
    'input.placeholder.scanBarcode': 'Scan or Enter Barcode',
    'input.placeholder.eventIdOrEventName': 'Input Event ID or Event Name',
    'input.placeholder.shortCode': 'Shortcode',
    'selectbox.selectMarket': 'Select Market',
    'selectbox.selectOutcome': 'Select Outcome',

    /* ================================================================================================================================= */

    /* 04. Login */
    'login.message.welcomeTo': 'Welcome!',
    'login.message.userPanel': 'User Interface for Cashier',
    'login.message.sport': 'Sport',
    'login.message.sportMean': 'is a means of raising people both physically and morally',
    'login.input.username': 'Username',
    'login.input.password': 'Password',
    'login.input.show': 'Show',
    'login.input.hide': 'Hide',
    'login.actions.login': 'Login',
    'login.actions.loading': 'Loading...',

    /* ================================================================================================================================= */

    /* 05. Filter & Sort */
    'filter.allCountries': 'All Countries',
    'filter.allCategories': 'All Categories',
    'filter.allLeagues': 'All Leagues',
    'filter.allTimes': 'All Times',
    'sort.byLeague': 'Sort By League',
    'sort.byTime': 'Sort By Time',
    'sort.byDescending': 'By descending',
    'sort.byAscending': 'By ascending',

    /* ================================================================================================================================= */

    /* 06. Title */
    'title.sports': 'Sports',
    'title.prematch': 'Prematch',
    'title.messages': 'Messages',
    'title.point': 'Others',
    'title.terminals': 'Terminals',
    'title.tickets': 'Tickets',
    'title.sportsBook': 'Sportsbook Print',
    'title.reports': 'Reports',
    'title.weeklyBalance': 'Balance Report',
    'title.creditLimit': 'Interim Payment Report',
    'title.consumptions': 'Consumptions',
    'title.results': 'Results',

    /* ================================================================================================================================= */

    /* 07. Betslip */
    'betSlip.emptyMessage': 'Your bet slip is empty. Click on any price to add a bet',
    'betSlip.betLine.return': 'Possible Win',
    'betSlip.betLine.betMax': 'Bet Max',
    'betSlip.betLine.closed': 'Closed',
    'betSlip.select.option.dontAccept': 'Don’t Accept If Odds Change',
    'betSlip.select.option.acceptAny': 'Accept Any Change',
    'betSlip.select.option.acceptIncrease': 'Accept If Odds Increase',
    'betSlip.combinations': 'Combinations',
    'betSlip.actions.clearAll': 'Clear All',
    'betSlip.actions.placeBets': 'Place Bet',
    'betSlip.actions.bookBet': 'Book a Bet',
    'betSlip.summary.numberOfBets': 'Number of Bets',
    'betSlip.summary.totalStake': 'Total Stake',
    'betSlip.summary.totalOdds': 'Total Odds',
    'betSlip.summary.toWin': 'Possible Win',
    'betSlip.summary.system': 'System',
    'betSlip.errors.wrongMarketSelectionCombo': 'Wrong Market Selection for Combo',
    'betSlip.errors.combinationOptions': 'Please, review combination options for your selections.',
    'betSlip.placeBets.betsInProcess': 'Bets in Process…',
    'betSlip.refresh.loadingTitle': 'Refreshing',
    'betSlip.placeBets.loadingInfoMessage': 'Your bet is loaded into the system',
    'betSlip.refresh.loadingInfoMessage': 'We are fetching the latest updates...',
    'betSlip.placeBets.successMessage': 'Bet(s) Accepted!',
    'betSlip.placeBets.ticketNumber': 'Ticket Number',
    'betSlip.placeBets.betId': 'Bet ID',
    'betSlip.placeBets.bonus': 'Bonus Amount',
    'betSlip.placeBets.winTax': 'Win Tax',
    'betSlip.placeBets.potentialPayout': 'Net Win',
    'betSlip.placeBets.windowWillClose': 'Window Will Close',
    'betSlip.placeBets.acceptOddChanges': 'Accept Odds Changes',
    'betSlip.actions.retainSelections': 'Retain Selections',
    'betSlip.actions.clear': 'Clear',
    'betSlip.actions.autoAccept': 'Auto Accept',
    'betSlip.actions.manually': 'Manually',

    /* Misc */
    langDropdownAze: 'Azeri',
    comingSoon: 'Coming Soon',
    allDevicesModalTitle: 'Cashier Devices',
    allDevicesModalDescription:
        'Please always keep your devices operational. This will make your work more sustainable.',
    allDevicesModalInternetConnection: 'Internet Connection',
    allDevicesModalPrinter: 'Printer',
    allDevicesModalScanner: 'Scanner',
    allDevicesModalRefresh: 'Refresh',
    allDevicesModalDone: 'Done',
    lockScreenModalTitle: `Your account is currently locked.`,
    lockScreenModalDescription: `You can open the account by entering your password in the appropriate box.`,
    lockScreenModalEnterPassword: `Enter Your Password`,
    lockScreenModalSubmitting: `Opening...`,
    lockScreenModalSubmitButton: `Open`,
    messagesTabsAll: `All`,
    messagesTabsRead: `Read`,
    messagesTabsNew: `New`,
    messagesTabsSaved: `Saved`,
    messagesTableColumnsNo: `No`,
    messagesTableColumnsType: `Status`,
    messagesTableColumnsMessageId: `Message ID`,
    messagesTableColumnsMessage: `Message`,
    messagesTableColumnsDate: `Date/Time`,
    messagesTableRowMore: `More`,
    messagesTableRowMessageStatusNew: `New`,
    messagesTableRowMessageStatusSaved: `Saved`,
    messagesTableRowMessageStatusRead: `Read`,
    messagesTableRowMoreModalSaveButton: `Save`,
    messagesTableRowMoreModalPrintButton: `Print`,
    messagesTableRowMoreModalMessageId: `Message ID :`,
    betSlipCombinationsSelection: `Combinations`,
    betSlipCombinationsSelectionSelected: `Selected`,
    betSlipCombinationsBets: `Bets`,
    othersSidebarTerminals: 'Terminals',
    othersSidebarTickets: 'Tickets',
    othersSidebarSportsbookPrint: 'Sportsbook',
    othersSidebarReports: 'Reports',
    othersSidebarBalanceReport: 'Balance Report',
    othersSidebarCreditLimitIncreaseReport: 'Increase Report',
    othersSidebarConsumptions: 'Consumptions',
    terminalsTableColumnsNo: 'No',
    terminalsTableColumnsTerminalName: 'Device Name',
    terminalsTableColumnsStatus: 'Status',
    terminalsTableColumnsVirtualBalance: 'Current Balance',
    languagesEnglish: 'English',
    languagesAzerbaijani: 'Azeri',
    eventsFiltersCategoriesAll: 'All Categories',
    eventsFiltersLeaguesAll: 'All Leagues',
    eventsFiltersLeaguesOutrights: 'Outrights',
    eventsFiltersPeriodsAll: 'All Times',
    eventsFiltersPeriodsFirstItem: 'Next 6 hours',
    eventsFiltersPeriodsSecondItem: 'Today',
    eventsFiltersPeriodsThirdItem: 'Tomorrow',
    eventsFiltersPeriodsFourthItem: 'This Week',
    eventsFiltersPeriodsFifthItem: 'Next 24 hours',
    eventsFiltersOrdersFirstItem: 'Sort By League',
    eventsFiltersOrdersSecondItem: 'Sort By Time',
    eventsFiltersOrdersThirdItem: 'Sort By MBN',
    betSlipTabsSingle: 'Single',
    betSlipTabsCombo: 'Combo',
    betSlipTabsSystem: 'System',
    betSlipErrorsSingleMbn: 'MBN not allowed.',
    betSlipErrorsComboMbn: 'MBN not allowed.',
    betSlipErrorsCombination: 'Please, review combination options for your selections.',
    betSlipErrorsEventTypeCombination:
        'Combination of these type bets (cybersports, normal, outrights) are not allowed.',
    betSlipErrorsLiveBetsNotAllowed: 'Live betting is not allowed from this terminal.',
    betSlipErrorsMbnCombination: 'MBN combinations not allowed.',
    betSlipErrorsMinStake: 'Minimum stake value is %(amount)s AZN',
    betSlipErrorsMaxStake: 'Maximum stake value is %(amount)s AZN',
    betSlipErrorsMinimumOdd: 'Odds under minimum allowed',
    betSlipErrorsMinimumTotalOdd: 'Total odds under minimum allowed',
    betSlipPlacedTicketFoldCount: '%(count)s fold',
    betSlipPlacedTicketFoldsCount: '%(count)s folds',
    betSlipPlacedTicketBetCount: '%(count)s bet',
    betSlipPlacedTicketBetsCount: '%(count)s bets',
    numericKeyboardSubmit: 'Submit',
    changePasswordModalTitle: 'Change your password',
    changePasswordModalOldPassPlaceholder: 'Enter Old Password',
    changePasswordModalNewPassPlaceholder: 'Enter New Password',
    changePasswordModalConfirmNewPassPlaceholder: 'Confirm New Password',
    changePasswordModalChangeButton: 'Change Password',
    changePasswordModalSuccessMessage: 'Successfully Changed!',
    bancoButton: 'B',
    interfaceLoadingLabel: 'Loading Bet Interface',
    headerOpenSession: 'Session is open',
    errorModalRefreshButton: 'Refresh',
    errorModalLogoutButton: 'Logout',
    errorModalCloseButton: 'Close',
    logoutModalTitle: 'Logout',
    logoutModalContent: 'Are you sure you want to log out?',
    logoutModalYesButton: 'Yes',
    logoutModalNoButton: 'No',
    ticketInformationPayWinButton: 'Pay Win',
    ticketInformationPayWinMaxPayAmountError: "Pay amount is greater than cashier's max payment limit",
    ticketInformationReprintButton: 'Reprint',
    ticketInformationReprintRequestButton: 'Reprint Request',
    ticketInformationReprintRequestSuccess: 'Successfully sent reprint request',
    ticketInformationCancelButton: 'Cancel ticket',
    ticketInformationCancelLoading: 'Ticket cancelling',
    ticketStatusAll: 'All',
    ticketStatusOpen: 'Open',
    ticketStatusCancelled: 'Cancelled',
    ticketStatusWon: 'Won',
    ticketStatusLost: 'Lost',
    ticketStatusDraw: 'Draw',
    ticketStatusVoid: 'Void',
    ticketStatusHalfLost: 'Half-Lost',
    ticketStatusHalfWon: 'Half-Won',
    ticketStatusRefunded: 'Refunded',
    ticketStatusPaid: 'Paid',
    ticketInformationBetLineStatusColumn: 'Status',
    ticketInformationEventIdColumn: 'Event ID',
    ticketInformationBetLineBancoColumn: 'Banco',
    ticketInformationBetLineDateColumn: 'Date',
    ticketInformationBetLineEventColumn: 'Event',
    ticketInformationBetLineLeagueColumn: 'League',
    ticketInformationBetLineScoreColumn: 'Score',
    ticketInformationBetLineMatchScoreColumn: 'Match Score',
    ticketInformationBetLineSelectionColumn: 'Selection',
    ticketInformationBetLineOddsColumn: 'Odds',
    ticketInformationBetLineDescriptionColumn: 'Description',
    ticketInformationBetLineStakeColumn: 'Stake',
    ticketInformationTitle: 'Ticket Information',
    ticketInformationTerminalNameColumn: 'Terminal Name',
    ticketInformationBetId: 'Bet ID',
    ticketInformationDateColumn: 'Ticket Date',
    ticketInformationNumberColumn: 'Barcode',
    ticketInformationTotalOddsColumn: 'Total Odds',
    ticketInformationTotalCostColumn: 'Ticket Cost',
    ticketInformationStakePerBetColumn: 'Stake Per Bet',
    ticketInformationExtraWinColumn: 'Extra Win',
    ticketInformationToWinColumn: 'To Win',
    ticketInformationWinTaxColumn: 'Win Tax',
    ticketInformationToPayColumn: 'To Pay',
    ticketInformationPaidByColumn: 'Paid by',
    ticketInformationPaidDateColumn: 'Paid Date',
    ticketInformationPaidColumn: 'Paid',
    ticketInformationHeaderBetType: 'Bet Type:',
    increaseReportErrorModalGoBackButton: 'Go Back',
    increaseReportErrorModalDefaultMessage: 'Something went wrong',
    increaseReportSuccessMessage: 'Successfully received increase request',
    increaseReportIncreaseButton: 'Increase',
    increaseReportSuccessModalOkButton: 'OK',
    filtersStartDatePlaceholder: 'Start date',
    filtersEndDatePlaceholder: 'End date',
    filtersSearchButton: 'Search',
    filtersClearButton: 'Clear',
    notAvailableDate: 'Not Available',
    balanceReportSummaryTablePaymentColumn: 'Payment',
    balanceReportSummaryTableLimitIncreaseColumn: 'Balance Increase',
    balanceReportSummaryTableExtraDebtColumn: 'Extra Debt/Credit',
    balanceReportSummaryTableDebtColumn: 'Debt/Credit',
    balanceReportSalesColumn: 'Sales',
    balanceReportAgentCommissionColumn: 'Commission',
    balanceReportTotalSaleColumn: 'Total',
    balanceReportCancellationColumn: 'Cancels',
    balanceReportTotalCancellationColumn: 'Total',
    balanceReportPaymentColumn: 'Payments',
    balanceReportTotalPaymentColumn: 'Total',
    balanceReportRefundColumn: 'Refunds',
    balanceReportTotalRefundColumn: 'Total',
    balanceReportRefundCommissionColumn: 'Refunds Commission',
    balanceReportTotalRefundCommissionColumn: 'Total',
    balanceReportVoucherSaleColumn: 'Voucher Sales',
    balanceReportTotalVoucherSaleColumn: 'Total',
    balanceReportVoucherRefundColumn: 'Voucher Refunds',
    balanceReportTotalVoucherRefundColumn: 'Total',
    balanceReportSportsBettingPrematch: 'Sports Betting - Prematch',
    balanceReportSportsBettingLive: 'Sports Betting - Live',
    balanceReportTotalColumn: 'Total',
    increaseReportsTableNoColumn: 'No',
    increaseReportsStatusColumn: 'Status',
    increaseReportsAmountColumn: 'Amount',
    increaseReportsRequestDateColumn: 'Request Date / Time',
    increaseReportsProcessingDateColumn: 'Processing Date / Time',
    increaseReportsStatusAll: 'All',
    increaseReportsStatusPending: 'Pending',
    increaseReportsStatusSuccessful: 'Successful',
    increaseReportsStatusFail: 'Fail',
    increaseReportsStatusBOIncrease: 'BO Success',
    increaseReportsStatusBODecrease: 'BO Success',
    sportsbookPreviewButton: 'Preview',
    ticketsFiltersOrdersAscending: 'By ascending',
    ticketsFiltersOrdersDescending: 'By descending',
    ticketsTabsOpenBets: 'Open Bets',
    ticketsTabsBettingHistory: 'Betting History',
    ticketsTableNoColumn: 'No',
    ticketsTableStatusColumn: 'Status',
    ticketsTableTerminalColumn: 'Terminal',
    ticketsTableBetIdColumn: 'Bet ID',
    ticketsTableBarcodeColumn: 'Barcode',
    ticketsTableTimeColumn: 'Time',
    ticketsTableTicketCostColumn: 'Ticket Cost',
    ticketsTableMaxWinColumn: 'Max. Win',
    ticketsTableBetTypeColumn: 'Bettype',
    ticketsTableDetailsButton: 'Details',
    resultsFiltersAllCategories: 'All Categories',
    resultsFiltersAllLeagues: 'All Leagues',
    resultsFiltersOrdersByTime: 'By Time',
    resultsFiltersOrdersByLeague: 'By League',
    resultsTableEventDateColumn: 'Event Date/Time',
    resultsTableEventIdColumn: 'Event ID',
    resultsTableCategoryColumn: 'Category',
    resultsTableLeagueColumn: 'League',
    resultsTableEventColumn: 'Event',
    resultsTableFullTimeColumn: 'Full Time',
    closeButton: 'Close',
    generalErrorModalTitle: 'Error',
    generalErrorModalDescription: 'There is an issue occurred.',
    changePasswordSuccessMessage: 'Changed password successfully.',
    filtersRanges3Hours: '3 hours',
    filtersRanges6Hours: '6 hours',
    filtersRanges12Hours: '12 hours',
    filtersRangesToday: 'Today',
    filtersRangesYesterday: 'Yesterday',
    filtersRangesThisWeek: 'This Week',
    filtersRangesLastWeek: 'Last Week',
    filtersRangesThisMonth: 'This Month',
    filtersRangesLastAccountingPeriod: 'Last Week',
    filtersRangesLastMonth: 'Last Month',
    filtersRangesRangeOption: 'Range',
    ticketsFiltersTypesCashier: 'Cashier',
    increaseReportRequestAmountPlaceholder: 'Amount',
    marketGroupsAllOption: 'All',
    marketGroupsExpand: 'Expand',
    marketGroupsCollapse: 'Collapse',
    marketGroupsMorePlaceholder: 'More...',
    betSlipErrorsMaxWin: 'Maximum win amount limit exceed',
    betSlipErrorsMaxBetLine: 'Maximum bet line count is %(count)s',
    searchResultNoOptions: 'No options',
    preMatchProducerIsDown: 'Pre-Match producer is down',
    liveProducerIsDown: 'Live producer is down',
    popularEvents: 'Popular Events',
    couponNotFound: 'Coupon not found',
    betSlipErrorsOddChange: 'Odds have changed',
    print: 'Print',
    noMarketsAvailable: 'No markets available',
    internetConnectionOnline: 'Online',
    internetConnectionOffline: 'Offline',
    socketConnectionIsDown: 'Socket connection lost',
    socketConnectionDownHelp: 'Please refresh page to get the latest data.',
    socketConnectionRefreshButton: 'Reload',
    newVersionNotificationMessage: 'New version is available',
    newVersionNotificationReload: 'Reload',
    couponGeneratedModalTitle: 'Coupon Generated',
    notAuthorized: 'Not authorized',
    eventTypesRegular: 'Regular',
    eventTypesOutright: 'Outrights',
    newMarketIcon: 'NEW',
};
